let index: number = 0;

const TradeNameGridPluginSettings: IPluginSettings = {
    name: 'ТН',
    mnemocode: 'trade_name_by_store_plugin',
    permission: 'TradeName',
    columns: [{
        order: index++,
        propertyName: 'tradeNameRus',
        propertyType: 'string',
        displayName: 'ТН (рус.)',
        visibility: true,
        favoriteFilter: true,
        width: 150
    }, {
        order: index++,
        propertyName: 'tradeNameLat',
        propertyType: 'string',
        displayName: 'ТН (лат.)',
        visibility: true,
        favoriteFilter: true,
        width: 150
    }, {
        order: index++,
        propertyName: 'important',
        propertyType: 'boolean',
        displayName: 'ЖНВЛП',
        visibility: true,
        favoriteFilter: true,
        width: 150
    }, {
        order: index++,
        propertyName: 'isLs',
        propertyType: 'boolean',
        displayName: 'Лек. средство',
        visibility: true,
        favoriteFilter: false,
        width: 150
    }, {
        order: index++,
        propertyName: 'isPrescription',
        propertyType: 'boolean',
        displayName: 'Рецептурный',
        visibility: true,
        favoriteFilter: false,
        width: 150
    }],
}

export default TradeNameGridPluginSettings